<template>
    <ClientOnly>
        <Transition
            name="fade"
            mode="out-in">
            <div
                v-if="isReady"
                v-bind="$attrs"
                class="absolute z-10 flex transition-all duration-1000">
                <img
                    v-for="star in count"
                    :key="star"
                    loading="lazy"
                    width="48"
                    height="48"
                    alt=""
                    src="/assets/svg/star.svg"
                    :class="[positionClasses, sizeClasses]"
                    class="opacity-40" />
            </div>
        </Transition>
    </ClientOnly>
</template>

<script setup lang="ts">
const props = defineProps({
    count: {
        type: Number as PropType<1 | 2>,
        default: 1,
    },
    reverse: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    size: {
        type: String as PropType<'small' | 'medium'>,
        default: 'medium',
    },
    opacity: {
        type: Boolean as PropType<boolean>,
        default: true,
    },
})

const isReady = ref(false)

const positionClasses = computed(() => {
    if (props.count === 1) return ''

    return props.reverse
        ? 'last:-left-4 last:-bottom-3'
        : 'last:-right-4 last:-bottom-3'
})

const sizeClasses = computed(() => {
    if (props.size === 'small') return 'size-4'

    return props.count === 2
        ? 'first:size-12 last:size-8 last:absolute'
        : 'size-12'
})

onMounted(() => {
    setTimeout(
        () => {
            isReady.value = true
        },
        Math.floor(Math.random() * 2000)
    )
})

onUnmounted(() => {
    isReady.value = false
})
</script>
